export class AnnunciInEvidenza{
  public IdCommessaAnnuncio : number = 0;
  public IdCommessaAnnuncioEnc : string = "";
  public IdCommessa : number = 0;
  public IdComune : number = 0;
  public ComuneNome : string = "";
  public ProvinciaNome : string = "";
  public FilialeCommessa : string = "";
  public Titolo : string = "";
  public Descrizione : string = "";
  public Luogo : string = "";
  public NrLavoratori : number = 0;
  public IdLivelloEsperienza : number = 0;
  public EsperienzaDurata : string = "";
  public IdLivelloIstruzione : number = 0;
  public IdAttestatoList : string = "";
  public IdLinguaList : string = "";
  public IdConoscenzaList : string = "";
  public DataScadenza : Date = new Date();
  public DataScadenzaStr : string = "";
  public IdPostingProviderList : string = "";
  public PostingProviderList : string = "";
  public PubblicatoInSapiens : boolean = false;
  public AnnuncioScaduto : boolean = false;
  public SmartWorking : boolean = false;
  public IdWordpressAnnuncio : number = 0;
  public Azienda : string = "";
  public Orario : string = "";
  public OrarioDesc : string = "";
  public Mansione : string = "";
  public TipoContratto : string = "";
  public IsCandidato : boolean = false;

  //custom
  public studyTypeSelected : string = "";
  public attestatiSelected : string = "";
  public languageKnowledgesSelected : string = "";
  public computerKnowledgesSelected : string = "";

  //info filiale
  public Indirizzo : string = "";
  public Mail : string = "";
  public Telefono : string = "";
}

export class CommesseAnnunciPortals{
  public Titolo : string = "";
  public Descrizione : string = "";
  public Anteprima : string = "";
  public Settore : string = "";
  public TipoContratto : string = "";
  public Mansione : string = "";
  public DataPubblicazioneStr : string = "";
  public OrarioDesc : string = "";
  public Luogo : string = "";
  public ProvinciaNome : string = "";
  public FilialeCommessa : string = "";
}

export class CommesseAnnuncioFacetPortal{
  public TotaleRecordAnnunci : number = 0;
  public ListaAnnunci : CommesseAnnunciPortals[] = [];
}

export class AnnunciFiltri{
  public RicercaLibera : string = "";
  public IdRegione : number = 0;
  public IdProvincia : number = 0;
  public IdComune : number = 0;
  public IdMansione : number = 0;
  public IdCCNLSettore : number = 0;
  public TipoContratto : string = "";
  public TipoOrario : number = 0;
  public Count : number = 0;
  public Offset : number = 0;

}

export class Annuncio{
  public IdCommessaAnnuncio : number = 0;
  public IdCommessaAnnuncioSecure : string = "";
  public Titolo : string = "";
  public PosizioniRicercate : number = 0;
  public Azienda : string = "";
  public LuogoDiLavoro : string = "";
  public Frazione : string = "";
  public ProvinciaNome : string = "";
  public ProvinciaSigla : string = "";
  public Mansione : string = "";
  public Settore : string = "";
  public FilialeDiRiferimento : string = "";
  public FilialeEmail : string = "";
  public FilialeTelefono : string = "";
  public FilialeIndirizzo : string = "";
  public JobDescription : string = "";
  public DataScadenza : Date = new Date();
  public DataPubblicazione: Date = new Date();
  public Orario : string = "";
  public TipoContrattoFiltro : string = "";
}

export class IdAnnuncioModel {
  public IdAnnuncio : number = 0;
  public IdAnnuncioEnc : string = "";
}
